module.exports = __webpack_public_path__ + "img/04.6bcfa6b7.png";